import { Divider, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import moment from 'moment';
import MovementAbcCurveReportForm from '@/components/Reports/MovementReports/AbcCurveReportForm';
import { useReportHandlers } from '@/hooks/useReportHandler';
import {
  AbcCurveFormValues,
  AbcCurveRequest,
  DateFilterByMap,
  FormatType,
} from '@/core/domain/reports/movements/abcCurve/abcCurve.types';
import { useAbcCurveReport } from '@/core/domain/reports/movements/abcCurve/abcCurve.hooks';

function MovementAbcCurvePage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<AbcCurveFormValues>();

  const abcCurveReport = useAbcCurveReport();
  const { fileLoading, setFileLoading, setFileUnloading, FILE_FORMAT } =
    useFileLoading();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const { initialDate, finalDate, companiesIds, filterDateBy, ...values } =
        await form.validateFields();

      const obj: AbcCurveRequest = {
        ...values,
        format: FILE_FORMAT[format] as FormatType,
        dateFilterType:
          typeof filterDateBy === 'number'
            ? DateFilterByMap[filterDateBy]
            : undefined,
        companiesIds: companiesIds && String(companiesIds),
        startDate: moment(initialDate).format('YYYY-MM-DD'),
        endDate: moment(finalDate).format('YYYY-MM-DD'),
      };

      const result = await abcCurveReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_curva_abc',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />
      <MovementAbcCurveReportForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}

export default MovementAbcCurvePage;
